import React from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';
import ExamIcon from 'app.feature/academy/component/icon/exam-icon-m.svg';
import ViewsIcon from 'app.feature/academy/component/icon/exam-views-icon-m.svg';
import { TExamsDetails } from 'app.type/examsDetails';
import { TExamLabelType } from 'app.type/examLabelType';
import { ExamTypeLabels } from 'app.feature/academy/cbt.detail/constant/examLabels';

const CbtRoundTableMobile = ({ examTitle, examDetail, handleSolveButtonClick }: any) => {
  return (
    <StyledWrapper>
      <h1>시험 정보</h1>
      <ul className="list-wrapper">
        {examDetail.map((exam: TExamsDetails) => {
          return (
            <li key={exam.examDetailIdx} className="list-box">
              <div className="list-inner-box">
                <h2>{`${examTitle} ${exam?.examDateOrNull?.substr(0, 4)}년 ${exam.examRound}`}</h2>
                {exam?.recentExamDetailSolves?.at(0)?.updatedAt && (
                  <small>
                    최근 풀이일 :{' '}
                    {dayjs(exam?.recentExamDetailSolves?.at(0)?.updatedAt).format('YYYY-MM-DD')}
                  </small>
                )}
                <p className="problem">
                  <span>{ExamTypeLabels[exam.type as TExamLabelType]}</span>
                  <span className="divider"></span>
                  <span>{exam.problemCount}문제</span>
                </p>
                <p className="view">
                  <span>
                    <ViewsIcon />
                    {Number(exam.viewCount).toLocaleString()}
                  </span>
                  <span>
                    <ExamIcon />
                    {Number(exam.solvedCount).toLocaleString()}
                  </span>
                </p>
              </div>
              <div className="btn-wrapper">
                <button
                  onClick={() => {
                    handleSolveButtonClick(exam.examDetailIdx);
                  }}
                  className="btn-cbt"
                >
                  풀기
                </button>
              </div>
            </li>
          );
        })}
      </ul>
    </StyledWrapper>
  );
};

export default CbtRoundTableMobile;

const StyledWrapper = styled.div`
  display: none;
  @media ${({ theme }) => theme.device.mobile} {
    display: block;

    h1 {
      font-size: 15px;
      color: #333;
      padding: 10px 0 10px 8px;
      margin: 0;
      border-top: 1px solid #666;
      border-bottom: 1px solid #e0e0e0;
      background-color: #fafafa;
    }

    .list-wrapper {
      padding: 0;
      margin: 0;
      .list-box {
        border-bottom: 1px solid #e0e0e0;
        display: flex;
        justify-content: space-between;
        padding: 15px 10px 10px 8px;
        align-items: center;
        .list-inner-box {
          width: 80%;
        }
        div {
          h2 {
            font-size: 15px;
            margin-bottom: 5px;
            font-weight: 600;
            color: #333;
            margin: 0;
            word-break: keep-all;
          }

          small {
            color: #01a0ff;
            font-size: 14px;
            font-weight: 300;
          }

          .problem {
            margin: 6px 0;
            display: flex;
            align-items: center;

            span {
              font-size: 14px;
              color: #666;
              font-weight: 300;
              &.divider {
                display: inline-block;
                width: 1px;
                height: 12px;
                background-color: #e0e0e0;
                margin: 0 6px;
              }
            }
          }

          .view {
            display: flex;
            align-items: center;
            flex-direction: row;
            margin: 0;
            span {
              color: #999;
              font-size: 14px;
              font-weight: 300;
              display: flex;
              align-items: center;
              margin-right: 5px;
              svg {
                margin-right: 5px;
              }
            }
          }
        }
      }
      .btn-wrapper {
        width: 20%;
        min-width: 71.5px;
        .btn-cbt {
          width: 100%;
          border: 1px solid #01a0ff;
          border-radius: 8px;
          color: #01a0ff;
          padding: 15px 20px;
          font-weight: 600;
          font-size: 13px;
        }
      }
    }
  }
`;
